import { defineComponent as _defineComponent } from 'vue'
import InlineSvg from "vue-inline-svg";


const __default__ = {
  name: "MapZoomLevelSetter",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  zoomLevel: {
    type: Number,
    default: 15,
  },
  minZoomLevel: {
    type: Number,
    default: 4,
  },
  maxZoomLevel: {
    type: Number,
    default: 20,
  },
},
  emits: ["zoomIn", "zoomOut"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const emitOnZoomIn = () => {
  if (props.zoomLevel >= props.maxZoomLevel) return;
  emit("zoomIn", props.zoomLevel + 1);
};

const emitOnZoomOut = () => {
  if (props.zoomLevel <= props.minZoomLevel) return;
  emit("zoomOut", props.zoomLevel - 1);
};

const __returned__ = { props, emit, emitOnZoomIn, emitOnZoomOut, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})